import { all } from "redux-saga/effects";
import getReasonArriveLateSaga from "./getReasonArriveLate";
import getReasonLeaveSaga from "./getReasonLeave";
import createReqArriveLateSaga from "./createReqArriveLate";
import getDirectionManagerSaga from "./getDirectionManager";
import getListArriveLateSaga from "./getListArriveLate";
import getTimeCheckingSaga from "./getTimeKeeping";
import getArriveLateDetailSaga from "./getArriveLateDetail";
import getListRequestLeaveSaga from "./getListRequestLeave";
import getListRequestLeaveManagerSaga from "./getListRequestLeaveManager";
import getListArriveLateConfigSaga from "./getListArriveLateConfig";
import getListEmployeeSaga from "./getListEmployee";
import getListArriveLateManagerSaga from "./getListArriveLateManager";
import deleteRequestSaga from "./deleteRequest";
import getRequestLeaveDetailSaga from "./getRequestLeaveDetail";
import getPaidLeaveBalanceSaga from "./getPaidLeaveBalance";
import getTimeCheckingSummarySaga from "./getTimeKeepingSummary";
import handleRequestSaga from "./handleRequest";
import getListRequestLeaveConfigSaga from "./getListRequestLeaveConfig";
import updateReqArriveLateSaga from "./updateReqArriveLate";
import checkIsExitsReqArriveLateSaga from "./checkIsExitsReqArriveLate";
import createReqLeaveSaga from "./createReqLeave";
import uploadFileSaga from "./uploadFile";
import getLeaveManagerReqSaga from "./getLeaveManagerReq";
import checkIsExitsReqLeaveSaga from "./checkExitsReqLeave";
import getHolidaysSaga from "./getHolidays";
import getListManagerOfDepartmentSaga from "./getListManagerOfDepartment";
import getTimekeepingMonthSaga from "./getTimekeepingMonth";
import getListFeedbackSaga from "./getListFeedback";
import getListFeedbackManagerSaga from "./getListFeedbackManager";
import sendFeedbackSaga from "./sendFeedback";
import getConfigMinDateSaga from "./getConfigMinDate";
import getListTimeKeepingHRSaga from "./getListTimeKeepingHR";
import getCategoryOptionSaga from "./getCategoryOption";
import exportTimeKeepingHRSaga from "./exportTimeKeepingHR";
import confirmTimeKeepingMonthSaga from "./confirmTimeKeepingMonth";
import exportTimeKeepingMonthSaga from "./exportTimeKeepingMonth";
import getListTimeKeepingManagerSaga from "./getListTimeKeepingManager";
import confirmTimeKeepingSaga from "./confirmTimeKeeping";
import exportTimeKeepingManagerSaga from "./exportTimeKeepingManager";
import getFeedbackDetailSaga from "./getFeedbackDetail";
import getTimeKeepingManagerDetailSaga from "./getTimeKeepingManagerDetail";
import getRangeTimeKeepingSaga from "./getRangeTimeKeeping";
import getEmployeeOfManagerSaga from "./getEmployeeOfManager";
import getHrReportSaga from "./getHrReport";
import exportHrReportSaga from "./exportHrReport";
import getTimeConfirmPeriodSaga from "./getTimeConfirmPeriod";
import getListEmployeeArriveLateRequestSaga from "./getListEmployeeArriveLateRequest";
import getListEmployeeFeedbackRequestSaga from "./getListEmployeeFeedbackRequest";
import getListEmployeeLeaveRequestSaga from "./getListEmployeeLeaveRequest";
import getEmployeeArriveLateDetailSaga from "./getEmployeeArriveLateDetail";
import getEmployeeFeedbackDetailSaga from "./getEmployeeFeedbackDetail";
import getEmployeeRequestLeaveDetailSaga from "./getEmployeeRequestLeaveDetail";
import getTimeCheckInOnlineSaga from "./timeCheckInOnline";
import checkInOnlineSaga from "./checkInOnline";
import exportEmployeeRequestSaga from "./exportEmployeeRequest";
import cancelRequestSaga from "./cancelRequest";
import importTimeKeepingSaga from "./importTimeKeeping";
import exportTemplateTimeKeepingSaga from "./exportTemplateTimeKeeping";
import updateLeaveMaternityOrderSaga from "./updateLeaveMaternityOrder";
import getManagerApproveEarlyRegisterSaga from "./getManagerApproveEarlyRegister";
import earlyRegistrationSaga from "./earlyRegistration";
import deleteEarlyRegistrationSaga from "./deleteEarlyRegistration";
import getEarlyRegistrationDetailSaga from "./getEarlyRegistrationDetail";

export default function* declareLeaveSaga() {
  yield all([
    getTimeCheckingSaga(),
    getArriveLateDetailSaga(),
    getReasonArriveLateSaga(),
    getReasonLeaveSaga(),
    createReqArriveLateSaga(),
    getDirectionManagerSaga(),
    getListArriveLateSaga(),
    getListRequestLeaveSaga(),
    getListArriveLateConfigSaga(),
    getListEmployeeSaga(),
    getListArriveLateManagerSaga(),
    getListRequestLeaveManagerSaga(),
    deleteRequestSaga(),
    getRequestLeaveDetailSaga(),
    getPaidLeaveBalanceSaga(),
    getTimeCheckingSummarySaga(),
    handleRequestSaga(),
    getListRequestLeaveConfigSaga(),
    updateReqArriveLateSaga(),
    checkIsExitsReqArriveLateSaga(),
    createReqLeaveSaga(),
    uploadFileSaga(),
    getLeaveManagerReqSaga(),
    checkIsExitsReqLeaveSaga(),
    getHolidaysSaga(),
    getListManagerOfDepartmentSaga(),
    getTimekeepingMonthSaga(),
    getListFeedbackSaga(),
    getConfigMinDateSaga(),
    getListFeedbackManagerSaga(),
    sendFeedbackSaga(),
    getListTimeKeepingHRSaga(),
    getCategoryOptionSaga(),
    exportTimeKeepingHRSaga(),
    confirmTimeKeepingMonthSaga(),
    exportTimeKeepingMonthSaga(),
    getListTimeKeepingManagerSaga(),
    confirmTimeKeepingSaga(),
    exportTimeKeepingManagerSaga(),
    getFeedbackDetailSaga(),
    getTimeKeepingManagerDetailSaga(),
    getRangeTimeKeepingSaga(),
    getEmployeeOfManagerSaga(),
    getHrReportSaga(),
    exportHrReportSaga(),
    getTimeConfirmPeriodSaga(),
    getListEmployeeArriveLateRequestSaga(),
    getListEmployeeFeedbackRequestSaga(),
    getListEmployeeLeaveRequestSaga(),
    getEmployeeArriveLateDetailSaga(),
    getEmployeeFeedbackDetailSaga(),
    getEmployeeRequestLeaveDetailSaga(),
    getTimeCheckInOnlineSaga(),
    checkInOnlineSaga(),
    exportEmployeeRequestSaga(),
    cancelRequestSaga(),
    importTimeKeepingSaga(),
    exportTemplateTimeKeepingSaga(),
    updateLeaveMaternityOrderSaga(),
    getManagerApproveEarlyRegisterSaga(),
    earlyRegistrationSaga(),
    deleteEarlyRegistrationSaga(),
    getEarlyRegistrationDetailSaga(),
  ]);
}
